import { createRef, h, Fragment } from "preact";
import { useLayoutEffect, useState } from "preact/hooks";

import Overlay from "../Overlay.jsx";

import i18n from "../../i18n";
import Carousel from "../Carousel.jsx";

export default function ImageCarouselDialog({
  images,
  initImage,
  onClose,
  onOpen,
}) {
  const dialogRef = createRef();
  const overlayRef = createRef();

  useLayoutEffect(() => {
    // TODO: Some of this stuff should belong to Overlay and some should go into a
    //       general Dialog component
    const overlay = overlayRef.current.base;
    overlay.classList.add("overlay--open");
    const wrapper = dialogRef.current;
    wrapper.classList.add("dialog--open");
    wrapper.addEventListener(
      "animationend",
      () => {
        onOpen && onOpen();
      },
      { once: true } // Does not work in IE, but who cares
    );

    return () => {
      overlay.classList.add("overlay--exit");
      wrapper.classList.add("dialog--exit");

      return new Promise(function (resolve) {
        wrapper.addEventListener("animationend", resolve);
      });
    };
  }, []);

  return (
    <Fragment>
      <Overlay onClick={onClose} ref={overlayRef}>
        <section class="dialog dialog--lightbox card" ref={dialogRef}>
          <Carousel start={initImage} images={images} inLightbox />
        </section>
      </Overlay>
    </Fragment>
  );
}
